import { css, etiColors, mediaQueries } from '@eti/styles';
import {
  Button as EtiButton,
  VerticalContainer,
  Label as EtiLabel,
  Price as EtiPrice,
} from '../styles/quickSortButton';

import { skeletonClassStyle } from './TripDetailsBoundSkeleton';

const buttonBarContainerStyles = css`
  align-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
`;

const iconSkeletonStyles = css`
  border-radius: 50%;
  display: none;
  height: 24px;
  ${skeletonClassStyle};
  width: 24px;

  @media ${mediaQueries.medium.up} {
    display: block;
    margin-right: 10px;
  }

  @media ${mediaQueries.large.up} {
    display: block;
    height: 32px;
    margin-right: 28px;
    width: 32px;
  }
`;

const editButtonStyles = css`
  > span {
    align-items: center;
    display: flex;
  }

  :hover {
    background: ${etiColors.white};
  }
`;

const editLabelStyles = css`
  background: ${etiColors.grayScale[8]};
  height: 8px;
  line-height: normal;
  margin-bottom: 3px;
  ${skeletonClassStyle};
  width: 3rem;

  @media ${mediaQueries.medium.up} {
    width: 5rem;
  }
`;

const editPriceStyles = css`
  background: ${etiColors.grayScale[8]};
  height: 10px;
  line-height: normal;
  max-width: 6rem;
  ${skeletonClassStyle};
  width: 4rem;

  @media ${mediaQueries.medium.up} {
    width: 7rem;
  }
`;

const QuickSortButtonBar = () => (
  <div className={buttonBarContainerStyles}>
    <EtiButton className={editButtonStyles}>
      <div className={iconSkeletonStyles} />
      <VerticalContainer>
        <EtiLabel className={editLabelStyles} />
        <EtiPrice className={editPriceStyles} />
      </VerticalContainer>
    </EtiButton>

    <EtiButton className={editButtonStyles}>
      <div className={iconSkeletonStyles} />
      <VerticalContainer>
        <EtiLabel className={editLabelStyles} />
        <EtiPrice className={editPriceStyles} />
      </VerticalContainer>
    </EtiButton>

    <EtiButton className={editButtonStyles}>
      <div className={iconSkeletonStyles} />
      <VerticalContainer>
        <EtiLabel className={editLabelStyles} />
        <EtiPrice className={editPriceStyles} />
      </VerticalContainer>
    </EtiButton>

    <EtiButton className={editButtonStyles}>
      <div className={iconSkeletonStyles} />
      <VerticalContainer>
        <EtiLabel className={editLabelStyles} />
        <EtiPrice className={editPriceStyles} />
      </VerticalContainer>
    </EtiButton>
  </div>
);

export default QuickSortButtonBar;
